import React from "react";
import blog1 from "../../../assets/img/product-detail/fertilizer-application1.jpg";
import blog2 from "../../../assets/img/product-detail/fertilizer-application-bg1.jpg";
import { FiChevronRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useGetBlogCatQuery } from "../../products/productSlice";

function BlogAside({ t }) {
  const { data, isLoading } = useGetBlogCatQuery();

  const newsArray = [
    {
      id: 1,
      date: "02 Apr",
      // url: blog1,
      shortInfo:
        "Cagliata is a soft, semi-finished cheese made from pasteurized cow's milk and rennet..",
      title: "Technical Articles",
      desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
      link: "Read more",
    },
    {
      id: 2,
      date: "02 Apr",
      // url: blog2,
      category: "Blog",
      shortInfo:
        "Incorporating whole grains into your diet can have a profound impact on your health.",
      title: "Industry News",
      desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
      link: "Read more",
    },
    {
      id: 3,
      date: "02 Apr",
      // url: blog3,
      category: "Blog",
      shortInfo: "I got my first premium designer bag when I was...",
      title: "Case Studies?",
      desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
      link: "Read more",
    },
    {
      id: 4,
      date: "02 Apr",
      // url: blog4,
      shortInfo:
        "The Amazing Health Benefits of Broccoli: Why You Should Add It to Your Plate",
      title: "Safety and Compliance",
      desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
      link: "Read more",
    },
    {
      id: 5,
      date: "02 Apr",
      // url: blog1,
      category: "Blog",
      shortInfo:
        "Celery is a low-calorie vegetable with a crisp texture and a wide range of health benefits",
      title: "New Technologies",
      desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
      link: "Read more",
    },
    {
      id: 6,
      date: "02 Apr",
      // url: blog2,
      category: "Blog",
      shortInfo:
        "Parsley is often used as a decorative garnish, but this vibrant herb has much more to offer than...",
      title: "Maintenance and Overhaul",
      desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
      link: "Read more",
    },
    {
      id: 7,
      date: "02 Apr",
      // url: blog3,
      category: "Blog",
      shortInfo:
        "Parsley is often used as a decorative garnish, but this vibrant herb has much more to offer than...",
      title: "The Importance of Maintenance",
      desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
      link: "Read more",
    },
    {
      id: 8,
      date: "02 Apr",
      // url: blog4,
      category: "Blog",
      shortInfo:
        "Parsley is often used as a decorative garnish, but this vibrant herb has much more to offer than...",
      title: "Blog",
      desc: "GGAS a part of the illustrious GGAS, is one of India’s largest listed, diversified engineering and construction company",
      link: "Read more",
    },
  ];

  return (
    <>
      <div className="blogAsideSec">
        <div className="blogCategory">
          <h4 className="asideTitle">{t("Our Blog Category")}</h4>
          <hr />
          <ul>
            {isLoading && (
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            )}

            {/* {data &&
              data.map((item) => {
                return (
                  <li key={item._id}>
                    <Link to="/">
                      <FiChevronRight />
                      {item.name}
                    </Link>
                  </li>
                );
              })} */}

            {newsArray.map((item) => {
              return (
                <li key={item.id}>
                  <Link to="/">
                    <FiChevronRight />
                    {item.title}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
        {/* <div className="recentPosts  ">
          <h4 className="asideTitle">recent posts</h4>
          <hr />
          <div className="recentItemInfo">
            <div className="recentImg">
              <img src={blog1} alt="Latest Blog" />
            </div>
            <div className="recentContent">
              <h6><Link to="/blog-detail">Top New Collection</Link></h6>
              <p className='date'>February 26, 2018</p>
            </div>
          </div>
          <div className="recentItemInfo  ">
            <div className="recentImg">
              <img src={blog2} alt="Latest Blog" />
            </div>
            <div className="recentContent">
              <h6><Link to="/blog-detail">Fashion Trends</Link></h6>
              <p className='date'>July 09, 2015</p>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
}

export default BlogAside;
